import type { BelgeInfoValues } from '../schemas/belgeInfoSchema'
import type { SablonSurum, WizardStep } from '../types'
import { stripPreview } from './templateHelpers'

const DRAFT_WIZARD_KEY = 'hr.belgeler.wizardDraft'
const ID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
const isId = (v: unknown): v is string => typeof v === 'string' && ID_RE.test(v)

export type WizardDraft = {
  step: WizardStep
  info: BelgeInfoValues
  surum: SablonSurum | null
  dirty?: boolean
  savedAt?: string
}

export function saveWizardDraft(draft: WizardDraft) {
  try {
    const surum = draft.surum ? stripPreview(draft.surum) : null
    localStorage.setItem(DRAFT_WIZARD_KEY, JSON.stringify({ ...draft, surum, savedAt: new Date().toISOString() }))
  } catch {
    /* quota */
  }
}

export function loadWizardDraft(): WizardDraft | null {
  try {
    const raw = localStorage.getItem(DRAFT_WIZARD_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as WizardDraft
    if (!parsed || typeof parsed.step !== 'number' || !parsed.info) return null
    // Eski taslaklarda pozisyon/kontrol sorumlusu serbest metindi; yalnız kayıt id'leri korunur.
    const info = parsed.info
    return {
      ...parsed,
      info: {
        ...info,
        pozisyonlar: (info.pozisyonlar ?? []).filter(isId),
        kontrolSorumlusu: isId(info.kontrolSorumlusu) ? info.kontrolSorumlusu : '',
      },
    }
  } catch {
    return null
  }
}

export function clearWizardDraft() {
  localStorage.removeItem(DRAFT_WIZARD_KEY)
}
